import React from "react";

class MonthBox extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            value: this.props.value || 'N/A',
        }
        this._handleClick = this._handleClick.bind(this)
    }

    UNSAFE_componentWillReceiveProps(nextProps){
        this.setState({
            value: nextProps.value || 'N/A',
        })
    }

    render() {

        return (
            <div className="box" onClick={this._handleClick}>
                <label>{this.state.value}</label>
            </div>
        )
    }

    _handleClick(e) {
        this.props.onClick && this.props.onClick(e)
    }
}


export default MonthBox;